var map = {
	"./image-1.jpg": 1360,
	"./image-10.jpg": 3917,
	"./image-11.jpg": 7463,
	"./image-12.jpg": 6536,
	"./image-2.jpg": 1679,
	"./image-3.jpg": 5298,
	"./image-4.jpg": 8897,
	"./image-5.jpg": 8948,
	"./image-6.jpg": 1523,
	"./image-7.jpg": 6758,
	"./image-8.jpg": 5749,
	"./image-9.jpg": 1784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5442;